<template>
  <v-dialog v-model="addArticleDialog" scrollable max-width="700px" persistent>
    <v-card>
      <v-toolbar color="white" fixed>
        <h3>{{ $i18n.t(label) }}</h3>
      </v-toolbar>
      <v-card-text>
        <v-container dense>
          <v-form v-model="isValid" ref="form">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="newArticle.name"
                  :label="$i18n.t('Name') + '*'"
                  :rules="validationrules.name"
                  required
                ></v-text-field>

                <v-checkbox :label="$i18n.t('Driver')" v-model="newArticle.forDriver"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-btn
                  class="float-right"
                  color="blue"
                  x-small
                  @click="newArticle.artifacts.push({});"
                >+ {{ $i18n.t("Add") }}</v-btn>
                <v-simple-table dense style="width:100%;">
                  <thead>
                    <tr>
                      <th class="text-left">{{ $i18n.t("Name") }}</th>
                      <th class="text-left">{{ $i18n.t("Units") }}</th>
                      <th class="text-right"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in newArticle.artifacts" :key="index">
                      <td>
                        <v-text-field v-model="item.name"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.units" type="number"></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-form>
          <!-- <v-row>
            <v-simple-table dense style="width:100%;">
              <template>
                <thead>
                  <tr>
                    <th class="text-left">{{ $i18n.t("Name") }}</th>
                    <th class="text-right"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in permits" :key="index">
                    <td>
                      <span v-show="!item.edit">{{item.type}}</span>
                      <span v-show="item.edit">
                        <v-text-field v-model="item.type"></v-text-field>
                      </span>
                    </td>
                    <td>
                      <v-btn
                        v-show="item.edit"
                        class="float-right"
                        color="green"
                        x-small
                        fab
                        text
                        :loading="addPermitLoading"
                        @click="saveOld(item);"
                      >
                        <v-icon>mdi-content-save</v-icon>
                      </v-btn>

                      <z-confirm-button
                        v-show="!item.edit"
                        class="float-right"
                        color="red lighten-1"
                        x-small
                        fab
                        text
                        :loading="addPermitLoading"
                        :message="$i18n.t('Do you want to delete this Permit ?')"
                        @click="deletePermitType(item)"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </z-confirm-button>

                      <v-btn
                        v-show="!item.edit"
                        class="float-right"
                        color="blue"
                        x-small
                        fab
                        text
                        @click="item.edit = true;"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>-->
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small>*indicates required field</small>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeArticleDialog">Close</v-btn>
        <v-btn
          color="success darken-1"
          @click="saveArticle()"
          :loading="addArticleLoading"
          :disabled="!isValid"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPost, doGet } from "@/store/common/module/apis";

@Component({
  name: "ArticleCreate",
  props: {
    showDialog: {
      default: false,
    },
    label: {
      default: "Add Article",
    },
    refreshArticles: {
      default: false,
    },
  },
})
export default class ArticleCreate extends Vue {
  addArticleDialog = false;
  isValid = true;
  newArticle = { artifacts: [] };
  addArticleLoading = false;
  articles = [];

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.addArticleDialog = val;
    // if (this.addArticleDialog) this.getArticles();
  }

  closeArticleDialog() {
    this.$emit("closeArticleDialog", false);
  }

  select(data) {
    this.$emit("select", data);
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
  };

  //   async getArticles() {
  //     try {
  //       const articles = await doGet("/api/article/list");
  //         for (let index = 0; index < articles.length; index++) {
  //           articles[index].edit = false;
  //         }
  //       this.articles = articles;
  //     } catch (e) {
  //       common.setError(e.message);
  //     }
  //   }

  async saveOld(_article) {
    try {
      this.addArticleLoading = true;
      common.setLoading(true);
      await doPost("/api/article/save", _article);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      //   this.getArticles();
      this.newArticle = { artifacts: [] };
      this.addArticleLoading = false;
      this.refreshArticles(true);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
      this.addArticleLoading = false;
    }
  }

  async saveArticle() {
    try {
      this.addArticleLoading = true;
      common.setLoading(true);
      this.newArticle = await doPost("/api/article/save", this.newArticle);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      //   this.getArticles();
      this.newArticle = { artifacts: [] };
      this.addArticleLoading = false;
      this.refreshArticles(true);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
      this.addArticleLoading = false;
    }
  }

  //   async deleteArticleType(article) {
  //     common.setLoading(true);
  //     try {
  //       await doGet("/api/article/" + article._id + "/delete");
  //       common.showMessage("Deleted Successfully");
  //       this.getArticles();
  //       this.refreshArticles(true);
  //     } catch (e) {
  //       common.setError(e.message);
  //     }
  //     common.setLoading(false);
  //   }
}
</script>
